import { render, staticRenderFns } from "./FilesRequestTable.vue?vue&type=template&id=69a5c70b&scoped=true"
import script from "./FilesRequestTable.vue?vue&type=script&lang=js"
export * from "./FilesRequestTable.vue?vue&type=script&lang=js"
import style0 from "./FilesRequestTable.vue?vue&type=style&index=0&id=69a5c70b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a5c70b",
  null
  
)

export default component.exports